import mappings from "modules/shared/models/mappings/mappings"

export default {
  authIntrospect: {
    authReference: {
      environmentId: "",
      userId: "",
      subscriptionId: "",
      companyId: "",
      agencyId: ""
    },
    authSession: {
      id: "",
      member: ""
    },
    authCallback: {
      url: "https://quantidia.com",
      userId: "userId",
      password: "password",
      auth: "auth",
      retries: "retries"
    },
    authNotify: {
      email: "email",
      sms: "sms",
      push: "push"
    }
  }
}